import { VISIT_TYPES, visitTypeLabels } from "~/services";
import type { VisitType } from "~/services";
import { Button } from "~/shared";
import { ErrorText } from "~/ui";
import { tw } from "~/utils";

const VISIT_TYPE_ARTICLE: Partial<Record<VisitType, string>> = {
  [VISIT_TYPES.INITIAL]: "an",
  [VISIT_TYPES.FOLLOW_UP]: "a",
};

const describeVisitType = (visitType: VisitType) =>
  `${VISIT_TYPE_ARTICLE[visitType] ?? "a"} ${visitTypeLabels[visitType]}`;

type ConvertSlotConfirmationProps = {
  show: boolean;
  currentVisitType: VisitType;
  targetVisitType: VisitType;
  isLoading: boolean;
  errorMessage?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConvertSlotConfirmation = ({
  show,
  currentVisitType,
  targetVisitType,
  isLoading,
  errorMessage,
  onClose,
  onConfirm,
}: ConvertSlotConfirmationProps) => {
  if (!show) return null;

  return (
    <div
      className="absolute inset-0 z-20 flex items-center justify-center"
      onClick={isLoading ? undefined : onClose}
    >
      <div
        className={tw(
          "w-full max-w-sm rounded-md bg-white shadow-xl",
          "flex flex-col gap-6 p-6",
        )}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex flex-col gap-2">
          <h3 className="text-dark-blue-gray text-lg font-bold leading-6">
            Convert slot?
          </h3>
          <p className="text-dark-blue-gray leading-6">
            Are you sure you want to convert this slot from{" "}
            {describeVisitType(currentVisitType)} to{" "}
            {describeVisitType(targetVisitType)}?
          </p>
        </div>

        {errorMessage ? <ErrorText>{errorMessage}</ErrorText> : null}

        <div className="flex gap-4">
          <Button
            variant="outline"
            size="sm"
            onClick={onClose}
            disabled={isLoading}
            className="flex-1"
          >
            Cancel
          </Button>

          <Button
            size="sm"
            onClick={onConfirm}
            isLoading={isLoading}
            className="flex-1"
          >
            Yes, Convert It
          </Button>
        </div>
      </div>
    </div>
  );
};
